import {getFilePreviewUrl, IconButton} from 'platform/components';

import {useLazyGetFileByIdQuery} from '@dms/api/base';
import {handleApiError} from '@dms/shared';

import {openFile} from 'shared/web';

interface PreviewFileIconProps {
  fileId: string;
  isDisabled?: boolean;
}

export function PreviewFileIcon(props: PreviewFileIconProps) {
  const [getFileById, {isLoading}] = useLazyGetFileByIdQuery();

  const previewFile = () => {
    if (props.isDisabled) {
      return;
    }

    getFileById({fileId: props.fileId})
      .unwrap()
      .then((file) => {
        const url = getFilePreviewUrl(file.originalUri);
        openFile(url);
      })
      .catch(handleApiError);
  };

  return (
    <IconButton
      icon="action/visibility"
      isDisabled={isLoading || props.isDisabled}
      onClick={previewFile}
    />
  );
}
